import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineContinent extends TitleBase {
	private disciplineValue: string;
	private continentValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.continentValue = this.getFilterValue(ParameterType.CONTINENT);

		return (
			this.indexableFilters.length >= 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.CONTINENT)
		);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.disciplineValue} in ${this.continentValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.titlePortalType} in the field of ${this.disciplineValue}`, ` in ${this.continentValue}`);
	}
}
